import { FC } from 'react'
import { useFormContext } from 'react-hook-form'
import get from 'lodash/get'

import InlineSpinner from '../display/InlineSpinner'
import { InputGroup, Label, ErrorLabel } from '../form'

import AuthPlacesInput, { SelectedPlace } from './AuthPlacesInput'

type Props = {
  ready?: boolean
  noMargin?: boolean
}

const AuthLocationField: FC<Props> = ({ ready = true, noMargin }) => {
  const {
    register,
    setValue,
    trigger,
    formState: { errors, isSubmitted },
  } = useFormContext()
  const error = get(errors, 'user[location]')
  const showError = Boolean(error) && isSubmitted

  return (
    <InputGroup lessMargin noMargin={noMargin}>
      <Label htmlFor="user[location]" error={showError}>
        Location
      </Label>

      {ready === false ? (
        <InlineSpinner />
      ) : (
        <AuthPlacesInput
          name="user[location]"
          onSelect={({ location, latitude, longitude }: SelectedPlace) => {
            // Google writes the chosen text straight into the DOM without an
            // input event, so form state must be told about it too.
            setValue('user[latitude]' as any, latitude, { shouldDirty: true })
            setValue('user[longitude]' as any, longitude, {
              shouldDirty: true,
            })
            if (location) {
              setValue('user[location]' as any, location, { shouldDirty: true })
            }
            trigger('user[location]' as any)
          }}
          error={showError}
        />
      )}

      {showError && (
        <ErrorLabel htmlFor="user[location]">
          {error?.message as string}
        </ErrorLabel>
      )}

      <input type="hidden" {...register('user[latitude]' as any)} />
      <input type="hidden" {...register('user[longitude]' as any)} />
    </InputGroup>
  )
}

export default AuthLocationField
